module.exports = __webpack_public_path__ + "static/img/student.38ebfe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/student.png
// module id = Weg0
// module chunks = 1